module.exports = __webpack_public_path__ + "media/images/svg/customer-43d79bb933b73812c7eb1a3cfb5bcf12.svg";